import { IDocumentDetailField } from 'common/document/interfaces/document-detail-field';
import { IVerificationResultByRecognition } from 'common/ui/interfaces/verification-result-by-recognition';
import { DocumentDetailFieldStatusEnum } from 'common/document/enums/document-detail-field-status.enum';

export type IFieldVerificationResult = {
  [key: string]: IVerificationResultByRecognition;
};

export const buildVerificationStatus = (
  inputData: IDocumentDetailField[] | null | undefined
): IFieldVerificationResult | undefined => {
  if (!inputData?.length || !Object.keys(inputData).length) {
    return undefined;
  }
  return Object.values(inputData).reduce(
    (hash: { [key: string]: any }, currentValue: any) => {
      hash[currentValue.fieldName] = currentValue?.verificationStatus;
      return hash;
    },
    {}
  );
};

export const shouldHideVerificationByStatus = (
  statuses: { [key: string]: any },
  field: string
) => {
  if (!statuses) {
    return false;
  }
  return (
    statuses[field] === undefined ||
    statuses[field] === DocumentDetailFieldStatusEnum.NO_BAR_CODE_DATA
  );
};
